import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { Card } from '@sohanscript/ui/card';
import { P } from '@sohanscript/ui/text';
import type { ComponentProps } from 'react';
import { Img } from '@/components/image';

type TestimonialsCardProps = ComponentProps<'div'> & {
	image: string;
	name: string;
	message?: string;
	designation: string;
};

export function TestimonialsCard({
	className,
	image,
	name,
	message,
	designation,
	...props
}: TestimonialsCardProps) {
	return (
		<Card
			className={cn('group glow-hover flex flex-col gap-4 p-4', className)}
			{...props}
		>
			<div className="flex items-center justify-between gap-3">
				<div className="flex min-w-0 items-center gap-3">
					<div className="size-10 shrink-0 overflow-hidden rounded-full border border-primary/20 bg-primary/10">
						<Img
							className="size-full object-cover"
							height={40}
							sizes="40px"
							src={image}
							width={40}
						/>
					</div>
					<div className="min-w-0">
						<P className="truncate font-semibold text-foreground-light">
							{name}
						</P>
						<P className="truncate text-2xs text-muted-foreground">
							{designation}
						</P>
					</div>
				</div>
				<Iconify
					icon="lucide:badge-check"
					className="size-4 shrink-0 text-success"
					aria-label="Verified testimonial"
				/>
			</div>
			<div className="flex items-center justify-between gap-3">
				<Iconify
					icon="lucide:quote"
					className="size-6 text-primary/40"
					aria-hidden
				/>
				<div className="flex items-center gap-2">
					<Iconify
						icon="lucide:star"
						className="size-3 fill-current text-primary"
						aria-hidden
					/>
					<span className="font-mono text-2xs text-primary">5.0</span>
				</div>
			</div>
			<P className="font-souvenir text-foreground/85 text-sm leading-relaxed">
				{message}
			</P>
		</Card>
	);
}
